import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import IndustryPage from "@/pages/IndustryPage";

export const Route = createFileRoute("/en/industries/pharma-biotech/")({
  head: () => buildRouteHead("/en/industries/pharma-biotech"),
  component: IndustryPage,
});

